import { defaultDirection } from "../constants/defaultValues";

export const mapOrder = (array, order, key) => {
  array.sort(function (a, b) {
    var A = a[key],
      B = b[key];
    if (order.indexOf(A + "") > order.indexOf(B + "")) {
      return 1;
    } else {
      return -1;
    }
  });
  return array;
};

export const getDateWithFormat = () => {
  const today = new Date();
  let dd = today.getDate();
  let mm = today.getMonth() + 1; //January is 0!

  var yyyy = today.getFullYear();
  if (dd < 10) {
    dd = "0" + dd;
  }
  if (mm < 10) {
    mm = "0" + mm;
  }
  return dd + "." + mm + "." + yyyy;
};

export const getCurrentTime = () => {
  const now = new Date();
  return now.getHours() + ":" + now.getMinutes();
};

export const getDirection = () => {
  let direction = defaultDirection;
  if (localStorage.getItem("direction")) {
    const localValue = localStorage.getItem("direction");
    if (localValue === "rtl" || localValue === "ltr") {
      direction = localValue;
    }
  }
  return {
    direction,
    isRtl: direction === "rtl",
  };
};

export const setDirection = (localValue) => {
  let direction = "ltr";
  if (localValue === "rtl" || localValue === "ltr") {
    direction = localValue;
  }
  localStorage.setItem("direction", direction);
};

export const decodePhoneNumber = (text) => {
  if (text.length) {
    return text.replace("+1", "").replace(/\D+/g, "");
  }
  return text;
};

export const encodePhoneNumber = (text) => {
  let stateToSave = "";
  if (!text) return stateToSave;
  text = text.replace("+1", "").replace(/[^0-9.]/g, "");

  if (text != "false" && text.length && text) {
    const match = text.replace(/\D+/g, "").match(/([^\d]*\d[^\d]*){1,10}$/)[0];
    if (match.length > 3) {
      const part1 = match.length > 2 ? `(${match.substring(0, 3)})` : match;
      const part2 = match.length > 3 ? ` ${match.substring(3, 6)}` : "";
      const part3 = match.length > 6 ? `-${match.substring(6, 10)}` : "";
      stateToSave = `${part1}${part2}${part3}`;
    } else {
      stateToSave = match;
    }
  }
  return stateToSave;
};

export const TIMEZONES = [
  // UTC
  { label: "UTC", value: "UTC" },

  // Africa
  { label: "Africa/Cairo", value: "Africa/Cairo" },
  { label: "Africa/Johannesburg", value: "Africa/Johannesburg" },
  { label: "Africa/Lagos", value: "Africa/Lagos" },
  { label: "Africa/Nairobi", value: "Africa/Nairobi" },

  // Asia
  { label: "Asia/Karachi (PK)", value: "Asia/Karachi" },
  { label: "Asia/Dubai (UAE)", value: "Asia/Dubai" },
  { label: "Asia/Kolkata (India)", value: "Asia/Kolkata" },
  { label: "Asia/Colombo", value: "Asia/Colombo" },
  { label: "Asia/Kathmandu", value: "Asia/Kathmandu" },
  { label: "Asia/Dhaka", value: "Asia/Dhaka" },
  { label: "Asia/Bangkok", value: "Asia/Bangkok" },
  { label: "Asia/Singapore", value: "Asia/Singapore" },
  { label: "Asia/Kuala_Lumpur", value: "Asia/Kuala_Lumpur" },
  { label: "Asia/Hong_Kong", value: "Asia/Hong_Kong" },
  { label: "Asia/Shanghai", value: "Asia/Shanghai" },
  { label: "Asia/Tokyo", value: "Asia/Tokyo" },
  { label: "Asia/Seoul", value: "Asia/Seoul" },

  // Europe
  { label: "Europe/London (UK)", value: "Europe/London" },
  { label: "Europe/Dublin", value: "Europe/Dublin" },
  { label: "Europe/Berlin (Germany)", value: "Europe/Berlin" },
  { label: "Europe/Paris", value: "Europe/Paris" },
  { label: "Europe/Madrid", value: "Europe/Madrid" },
  { label: "Europe/Rome", value: "Europe/Rome" },
  { label: "Europe/Amsterdam", value: "Europe/Amsterdam" },
  { label: "Europe/Zurich", value: "Europe/Zurich" },
  { label: "Europe/Stockholm", value: "Europe/Stockholm" },
  { label: "Europe/Istanbul", value: "Europe/Istanbul" },
  { label: "Europe/Moscow", value: "Europe/Moscow" },

  // America – North
  { label: "America/New_York (EST)", value: "America/New_York" },
  { label: "America/Chicago (CST)", value: "America/Chicago" },
  { label: "America/Denver (MST)", value: "America/Denver" },
  { label: "America/Los_Angeles (PST)", value: "America/Los_Angeles" },
  { label: "America/Phoenix", value: "America/Phoenix" },
  { label: "America/Toronto", value: "America/Toronto" },
  { label: "America/Vancouver", value: "America/Vancouver" },
  { label: "America/Mexico_City", value: "America/Mexico_City" },

  // America – South
  { label: "America/Sao_Paulo", value: "America/Sao_Paulo" },
  { label: "America/Buenos_Aires", value: "America/Buenos_Aires" },
  { label: "America/Santiago", value: "America/Santiago" },
  { label: "America/Bogota", value: "America/Bogota" },
  { label: "America/Lima", value: "America/Lima" },

  // Australia / Oceania
  { label: "Australia/Sydney", value: "Australia/Sydney" },
  { label: "Australia/Melbourne", value: "Australia/Melbourne" },
  { label: "Australia/Brisbane", value: "Australia/Brisbane" },
  { label: "Australia/Perth", value: "Australia/Perth" },
  { label: "Pacific/Auckland", value: "Pacific/Auckland" },
];
